package com.mps.asc_app.util

actual fun currentEpochMillis(): Long = kotlin.js.Date.now().toLong()

